import BuildRow from './BuildRow.js';
import type { Track } from '../../api.js';
import type { ThemeDirection } from './types.js';

export default function BuildQueueCard({
  tracks,
  direction,
  recentCompleted,
  onOpen,
}: {
  tracks: Track[];
  direction: ThemeDirection;
  recentCompleted: Track[];
  onOpen: (id: string) => void;
}) {
  return (
    <div className="conductor-card">
      <div className="conductor-card-header">
        <span className="conductor-card-title">
          {direction === 'podium' ? 'Builds' : 'Build queue'}
        </span>
      </div>
      <div className="build-list">
        {tracks.length === 0 && <div className="empty">No builds yet.</div>}
        {tracks.map((track) => (
          <BuildRow key={track.id} track={track} recentCompleted={recentCompleted} onOpen={onOpen} />
        ))}
      </div>
    </div>
  );
}
